import { useParameterStore } from "@/frontend/store/ParameterStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";
import { ItemReferenceParams } from "@/types/itemReferenceTypes";
import { ParameterType, ParameterInputType, ParameterReply, ParameterSubjectType, SelectableParameter } from "@/types/parameterTypes";
import { useShallow } from "zustand/react/shallow";
import { GenericParameterSelect } from "./GenericParameterSelect";
import { ParameterAddButton } from "./ParameterAddButton";
import { ContainerTreeObject } from "@/frontend/types/navigationTypes";

export function OperationParameterSelect(props: {
  scenario?: ContainerTreeObject,
  currentReference?: ItemReferenceParams,
  currentParameter?: SelectableParameter,
  parameters: SelectableParameter[],
  parameterType: ParameterType,
  inputType: ParameterInputType,
  createReference: (parameter: SelectableParameter) => void,
  fieldType: CUSTOM_FIELD_TYPES
}) {
  const { scenario, currentParameter, currentReference, parameters, parameterType, inputType, createReference, fieldType } = props;
  const deleteReference = useParameterStore(state => state.deleteReference);
  const step = useTreeStore(useShallow(state => state.containerLookup[scenario?.parentId || '']));
  const defaultInputType = step?.container?.isRepeatingStep() ? ParameterInputType.LIST : inputType;

  const onCloseModal = async (response?: ParameterReply) => {
    if (response && response.parameter) {
      if (currentReference) {
        void deleteReference(currentReference.id);
      }

      createReference(response.parameter);
    }
  };

  return (
    <GenericParameterSelect
      parameters={parameters}
      currentParameter={currentParameter}
      currentReference={currentReference}
      createReference={createReference}
      deleteReference={(id) => void deleteReference(id)}
      blockSelectNone={inputType === ParameterInputType.TABLE}
    >
    { scenario && <div className='dropdown-item'>
      <ParameterAddButton
        subjectId={scenario?.parentId}
        parameterType={parameterType}
        subjectType={ParameterSubjectType.STEP}
        customFieldType={fieldType}
        onCreate={(response) => void onCloseModal(response)}
        defaultInputType={defaultInputType}
      />
      </div> }
    </GenericParameterSelect>
  );
}
